"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    accordionPanelClassNames: function() {
        return accordionPanelClassNames;
    },
    useAccordionPanelStyles_unstable: function() {
        return useAccordionPanelStyles_unstable;
    }
});
const _react = require("@griffel/react");
const accordionPanelClassNames = {
    root: 'fui-AccordionPanel'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        B6of3ja: "f1hu3pq6",
        t21cq0: [
            "fkujibs",
            "f199hnxi"
        ],
        jrapky: "f19f4twv",
        Frg6f3: [
            "f199hnxi",
            "fkujibs"
        ]
    }
}, {
    d: [
        ".f1hu3pq6{margin-top:0;}",
        ".fkujibs{margin-right:var(--spacingHorizontalM);}",
        ".f199hnxi{margin-left:var(--spacingHorizontalM);}",
        ".f19f4twv{margin-bottom:0;}"
    ]
});
const useAccordionPanelStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(accordionPanelClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useAccordionPanelStyles.styles.js.map
